import Vue from 'vue'

const numberFormat = new Intl.NumberFormat(['nl-NL'], {
  maximumFractionDigits: 2
})

Vue.filter('formatFileSize', (value) => {
  if (value === null) {
    return value
  }

  if (value > Math.pow(1024, 2)) {
    return `${numberFormat.format(value / Math.pow(1024, 2))} MiB`
  }

  if (value > 1024) {
    return `${numberFormat.format(value / 1024)} KiB`
  }

  return `${numberFormat.format(value)} B`
})
